import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FileUpload } from '../../models/fileUpload.model';
import { FileUploadService } from '../../services/fileupload.service';
import { FileUploadType } from '../../models/fileUploadType.enum';
import { FileUploadStatus } from '../../models/fileUploadStatus.model';
import { AuthService } from '../../services/auth.service';


@Component({
    selector: 'protocol-modal-dialog',
    templateUrl: 'protocol-modal-dialog.component.html',
    styleUrls: ['./protocol-modal-dialog.component.scss'],
    standalone: false
})

export class UploadProtocolModalDialogComponent implements OnDestroy {

  public titleHeader: string = null;
  public title: string;
  public accept: boolean = false;

  public uploads: FileUpload[];
  public uploadsFiltered: FileUpload[];
  public displayedColumns = ['date', 'fileType', 'fileName'];
  public tabledata: MatTableDataSource<FileUpload>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  public selectedUpload: FileUpload;

  constructor(public dialogRef: MatDialogRef<UploadProtocolModalDialogComponent>, private fileUploadService: FileUploadService,
    private authService: AuthService) {

    this.fileUploadService.getAllUploadFiles().then(data => {
      if (data?.length) {
        data = data.sort(function (a, b) {
          return new Date(b.uploadTimestamp).getTime() - new Date(a.uploadTimestamp).getTime();
        });
      }
      this.uploads = data;
      this.uploadsFiltered = [...data];
      // console.log('data => ', data);
      this.initializeTable();
    });

    this.pollDetails();
  }

  ngOnDestroy(): void {
    this.stopPollDetails();
  }

  private initializeTable() {
    this.tabledata = new MatTableDataSource(this.uploadsFiltered);
    this.tabledata.sort = this.sort;
    this.tabledata.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'fileType': return item.fileType;
        case 'fileName': return item.fileName;
        case 'date': return new Date(item.uploadTimestamp).getTime();
        default: return item[property];
      }
    }
  }

  // Search
  public searchTerm: string = "";

  search(): void {
    this.uploadsFiltered = this.uploads;
    let term = this.searchTerm.replace(/\s/g, "").toLowerCase();
    this.uploadsFiltered = this.uploads.filter(function (tag) {
      if (tag.fileType == FileUploadType.TlsRootCertificate
        && ('Zertifitkat').toLowerCase().indexOf(term) >= 0) {
        return true;
      }
      if (tag.fileType == FileUploadType.TerminalSetupFile
        && ('Setupdatei').toLowerCase().indexOf(term) >= 0) {
        return true;
      }
      return (tag.fileName && tag.fileName.toLowerCase().indexOf(term) >= 0);
    });

    this.initializeTable();
  }

  public isActive(data: FileUpload) {
    return this.selectedUpload == data;
  }

  public fileUploadDetails: FileUploadStatus[];
  public openDetails(data: FileUpload, event: PointerEvent) {
    this.selectedUpload = data;

    this.fileUploadService.getUploadFile(data?.id).then(data => {
      // console.log('file upload infos => ', data);
      this.fileUploadDetails = data;
    });
  }

  public updateData() {
    if (this.selectedUpload) {
      this.openDetails(this.selectedUpload, null);
    }
  }


  private readonly pollTimeInMS: number = 5000;
  private timerID: any; // NodeJs.Timeout
  public pollingStopped: boolean = false;
  private pollDetails() {
    if (this.authService.isLoggedIn) {
      this.restartPoll();
    } else {
      this.stopPollDetails();
    }
  }

  private pollStatusList() {
    if (!this.timerID) {
      this.updateData();
      this.timerID = setInterval(() => {
        if (this.authService.isLoggedIn) {
          this.updateData();
        } else {
          this.stopPollDetails();
        }
      }, this.pollTimeInMS);
    }
  }

  public stopPollDetails() {
    clearInterval(this.timerID);
    this.timerID = null;
  }

  public restartPoll() {
    this.stopPollDetails();
    if (!this.pollingStopped) {
      this.pollStatusList();
    }
  }

  public closeDialog() {
    this.stopPollDetails();
    this.dialogRef.close();
  }

  public trackByIndex(i: number) {
    return i;
  }
}
